var map = {
	"./animation-key.gif": 69,
	"./animation-key2.gif": 70,
	"./animation-key3.gif": 71,
	"./background-info.svg": 72,
	"./background-intro.jpg": 73,
	"./background-login-bottom.svg": 74,
	"./background-login-top.svg": 75,
	"./background-login.svg": 76,
	"./background-night.svg": 77,
	"./background-splash-bottom.svg": 78,
	"./background-splash-middle.svg": 79,
	"./background-splash-top.svg": 80,
	"./background-the-end.svg": 81,
	"./button-info-hover.svg": 82,
	"./button-info.svg": 83,
	"./button-login-hover.svg": 84,
	"./button-login.svg": 85,
	"./button-menu-hover.svg": 86,
	"./button-menu.svg": 87,
	"./button-play-hover.svg": 88,
	"./button-play.svg": 89,
	"./cards/feedback.svg": 31,
	"./cards/mission.svg": 39,
	"./decks/blue-back.svg": 90,
	"./decks/blue-deck.svg": 91,
	"./decks/pink-back.svg": 92,
	"./decks/pink-deck.svg": 93,
	"./flower1.svg": 94,
	"./flower2.svg": 95,
	"./icon-arrow-down.svg": 96,
	"./icon-check.svg": 97,
	"./icon-close.svg": 40,
	"./icon-eye.svg": 98,
	"./icon-info.svg": 99,
	"./icon-labyrinth.svg": 100,
	"./icon-loading-key.svg": 101,
	"./icon-loading.svg": 102,
	"./icon-sortable.svg": 103,
	"./logo-cgl.png": 104,
	"./logo-region-s.png": 105,
	"./logo-tryg.png": 106,
	"./mazes/key-horizontal-ghost.svg": 41,
	"./mazes/key-horizontal-unlocked.svg": 42,
	"./mazes/key-horizontal.svg": 43,
	"./mazes/key-rotated-unlocked.svg": 44,
	"./mazes/key-rotated.svg": 45,
	"./mazes/key-vertical-ghost.svg": 46,
	"./mazes/key-vertical-unlocked.svg": 47,
	"./mazes/key-vertical.svg": 48,
	"./mazes/maze-1.svg": 49,
	"./mazes/maze-2.svg": 50,
	"./mazes/maze-3.svg": 51,
	"./portal/background-ground.svg": 107,
	"./portal/background-portal-1.svg": 108,
	"./portal/background-portal-2.svg": 109,
	"./portal/background-portal-3.svg": 110,
	"./portal/background-portal-4.svg": 111,
	"./portal/background-portal-5.svg": 112,
	"./portal/gate.svg": 113,
	"./portal/key-hole-unlocked.svg": 114,
	"./portal/key-hole.svg": 115,
	"./portal/maze-left.svg": 116,
	"./portal/maze-right.svg": 117,
	"./progress/icon-moon.svg": 118,
	"./progress/icon-moon2.svg": 119,
	"./progress/icon-sun.svg": 120,
	"./progress/maze-floor.svg": 121,
	"./progress/maze-portal.svg": 122,
	"./stats/heart-filled.svg": 123,
	"./stats/heart.svg": 124,
	"./stats/shield-filled.svg": 125,
	"./stats/shield.svg": 126,
	"./stats/sun-filled.svg": 127,
	"./stats/sun.svg": 128,
	"./stats/water-filled.svg": 129,
	"./stats/water.svg": 130,
	"./surveys/therapist-2.svg": 52,
	"./surveys/therapist.svg": 53,
	"./title.svg": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;